import React from 'react'
import { DataTableFiltersState, NestedDataTableState } from '../../../../shared/components/DataTable'
import { LinkedRecordsPanel } from '../../../../shared/components/LinkedRecordsPanel'
import useActivityStatuses from '../../../../shared/hooks/useActivityStatuses'
import useActivitiesDisplayName from '../../../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import { useGetActivitiesQuery } from '../../../../shared/queries/useGetActivitiesQuery'
import { getActivityColumns } from '../ActivityTable.columns'
import { DEFAULT_LINKED_ACTIVITY_COLUMN_IDS, getActivityPath } from '../ActivityTable.constants'
import { getActivityFilterDefinitions, getActivitySearchValues } from '../ActivityTable.filters'
import { ActivityColumnId } from '../ActivityTable.types'
import { useActivityDisplayNames } from '../useActivityDisplayNames'
import { useActivityRows } from '../useActivityRows'
import { renderActivityCell } from './renderActivityCell'

type LinkedActivitiesPanelProps = {
    ownerName: string
    ownerLabel: string
    linkedIds: string[] | undefined
    filtersState: DataTableFiltersState
    state: NestedDataTableState<ActivityColumnId>
}

export const LinkedActivitiesPanel = ({
    ownerName,
    ownerLabel,
    linkedIds,
    filtersState,
    state,
}: LinkedActivitiesPanelProps) => {
    const { getActivityStatusDetails } = useActivityStatuses()
    const activityDisplayNames = useActivityDisplayNames()
    const activityDisplayName = useActivitiesDisplayName()
    const activitiesQuery = useGetActivitiesQuery()
    const activityRows = useActivityRows(activitiesQuery.data)

    return (
        <LinkedRecordsPanel
            ownerName={ownerName}
            ownerLabel={ownerLabel}
            recordsQuery={activitiesQuery}
            records={activityRows}
            linkedIds={linkedIds}
            recordDisplayName={activityDisplayName}
            columns={getActivityColumns(activityDisplayNames)}
            filterDefinitions={getActivityFilterDefinitions(
                getActivityStatusDetails,
                activityDisplayNames,
                DEFAULT_LINKED_ACTIVITY_COLUMN_IDS
            )}
            getSearchValues={getActivitySearchValues}
            renderCell={renderActivityCell(getActivityStatusDetails)}
            getRecordName={(activity) => activity.title}
            getRecordPath={getActivityPath}
            filtersState={filtersState}
            state={state}
        />
    )
}

export default LinkedActivitiesPanel
